import { EmailDraft } from '../../../context'
import { useEmailDraftProvider } from '../Email.hooks'

function EmailDraftProvider({ DraftContext = EmailDraft, children, prefix }) {
  const value = useEmailDraftProvider(prefix)

  return <DraftContext value={value}>{children}</DraftContext>
}

export default EmailDraftProvider
